module.exports = __webpack_public_path__ + "img/facebook.d133b91c.png";